import { Row } from "react-bootstrap";

export const Footer = () =>
    <Row className="pt-5">
        <div style={{ fontSize: "80%", paddingTop: "1rem"}}>
            The development of MRR is a part of the project titled “Development of Open Platform Technologies for Smart Maritime Safety and Industries” (PES4070)<br />funded by the Korea Research Institute of Ships and Ocean Engineering (KRISO). This environment is currently operated by <a href="https://www.kriso.re.kr/eng/" target="_blank">KRISO</a> on behalf of <a href="https://www.iala-aism.org/" target="_blank">IALA</a>.
        </div>
    </Row>